export default __webpack_public_path__ + "static/workingguideimage2-8f3899922aaaf3d24fc46785fea9cd1c.jpeg";